import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';

/** Tidy stand-in for screens delivered by later tasks (docs/spec/13). */
export function PlaceholderPage({ titleKey, task }: { titleKey: string; task: string }) {
  const { t } = useTranslation();
  const params = useParams();
  const ids = Object.entries(params).filter(([, v]) => v);

  return (
    <div>
      <PageHeader title={t(titleKey)} />
      <div className="p-6">
        <div className="flex max-w-xl items-start gap-3 rounded-lg border border-dashed p-5">
          <Construction className="mt-0.5 size-5 text-muted-foreground" />
          <div>
            <div className="text-sm font-medium">{t('placeholder.comingSoon')}</div>
            <div className="mt-1 text-xs text-muted-foreground">{t('placeholder.task', { task })}</div>
            {ids.length > 0 && (
              <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-xs">
                {ids.map(([k, v]) => (
                  <div key={k} className="contents">
                    <dt className="text-muted-foreground">{k}</dt>
                    <dd className="font-mono">{v}</dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto mt-16 max-w-md text-center">
      <h1 className="text-lg font-semibold">{t('pages.notFound')}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t('errors.notFoundBody')}</p>
      <Link to="/" className="mt-4 inline-block text-sm text-accent hover:underline">
        {t('common.home')}
      </Link>
    </div>
  );
}
